import React, { useEffect, useState } from 'react';
import Iframe from './Iframe';
import { startOfRamadan, endOfRamadan } from '../constants/importantDates';

const formatTime = (time) => time < 10 ? `0${time}` : time;

const calculateTimeDifference = (targetTime, currentTime) => {
	const diff = new Date(targetTime).getTime() - currentTime;
	return {
		diff,
		hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
		minutes: Math.floor((diff / 1000 / 60) % 60),
		seconds: Math.floor((diff / 1000) % 60)
	};
};

const getRamadanStatus = (todaysDate) => {
	const isEidDay = endOfRamadan === todaysDate;
	const isMonthOfRamadan = todaysDate >= startOfRamadan && todaysDate <= endOfRamadan;
	const oneDay = 24 * 60 * 60 * 1000;

	const diffDays = isMonthOfRamadan
		? Math.round((endOfRamadan - todaysDate) / oneDay)
		: Math.round((startOfRamadan - todaysDate) / oneDay);

	const ramadanDayNumber = isMonthOfRamadan
		? Math.abs(Math.round((startOfRamadan - todaysDate) / oneDay))
		: null;

	return { isEidDay, isMonthOfRamadan, diffDays, ramadanDayNumber };
};

const getUnixTime = (date, time) => {
	try {
		if (!date || !time) {
			console.error("Invalid date or time:", date, time);
			return new Date().toUTCString();
		}
		const [day, month, year] = date.split('/');
		return new Date(`${month}/${day}/${year} ${time}`).toUTCString();
	} catch (error) {
		console.error("Error parsing date/time:", error);
		return new Date().toUTCString();
	}
}

// Helper to safely get location value (handles both array and string formats)
const getLocationValue = (value) => {
	if (!value) return null;
	return Array.isArray(value) ? value[0] : value;
};

function Timer({ iftarData, sehriData, currentLocation }) {
	const [currentTime, setCurrentTime] = useState(new Date().getTime());

	const iftarTime = getUnixTime(iftarData.date, iftarData.time);
	const sehriTime = getUnixTime(sehriData.date, sehriData.time);

	const sehriTimeDiff = calculateTimeDifference(sehriTime, currentTime);
	const iftarTimeDiff = calculateTimeDifference(iftarTime, currentTime);

	const timeBetween = sehriTimeDiff.diff > 0 ? sehriTimeDiff : iftarTimeDiff;
	const todaysDate = new Date().setHours(0, 0, 0, 0);
	const { isEidDay, isMonthOfRamadan, diffDays, ramadanDayNumber } = getRamadanStatus(todaysDate);

	useEffect(() => {
		const interval = setInterval(() => setCurrentTime(new Date().getTime()), 1000);
		return () => clearInterval(interval);
	}, []);

  // Auto-reload when timer expires, but add a small buffer to avoid constant reloads
  useEffect(() => {
    if (timeBetween.diff <= 0 && timeBetween.diff > -60000) { // Within 1 minute after
      console.log("Prayer time passed, reloading for new times...");
      setTimeout(() => window.location.reload(), 2000); // 2 second delay for user to see
    }
  }, [timeBetween.diff]);

  const { hours, minutes, seconds } = timeBetween;
  const timeString = `${hours} hrs ${formatTime(minutes)} mins ${formatTime(seconds)} secs`;

  // Get location display string with fallback
  const locationDisplay = getLocationValue(currentLocation?.town) ||
                          getLocationValue(currentLocation?.city) ||
                          getLocationValue(currentLocation?.state) ||
                          getLocationValue(currentLocation?.country) ||
                          "Location Unknown";

	return (
		<>
      <div className="logo">
        {isEidDay ? (
          <Iframe title="eid" src="https://giphy.com/embed/3o1MbsqpBthubCto1f" />
        ) : (
          <Iframe
            title={isMonthOfRamadan ? "ramadan" : "passedRamadan"}
            src={isMonthOfRamadan
              ? "https://giphy.com/embed/nKA4aQgYPQKHbRA10y"
              : "https://giphy.com/embed/f8Q0nkyNbEUGkfbrMj"
            }
          />
        )}
      </div>
			<div className="date">
				<h1>
          {new Date().toLocaleDateString(undefined, {
            weekday: 'short',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          })}
        </h1>
        <div className='ramadan-info'>
          <div className='location'>
            <div
              onClick={() => {
                localStorage.removeItem('cachedLocation');
                localStorage.removeItem('lastFetchDate');
                localStorage.removeItem('prayerTimings');
                window.location.reload();
              }}
              style={{ cursor: 'pointer' }}
            >
              <h3>📍 {locationDisplay}</h3>
              <h4>Tap to reset</h4>
            </div>
          </div>
          {diffDays - 1 > 0 && (
            <>
              <h2>Days till {isMonthOfRamadan ? 'Eid' : 'Ramadan'}: {diffDays - 1} day{diffDays - 1 === 1 ? '' : 's'}</h2>
              {isMonthOfRamadan && <h2>{ramadanDayNumber + 1} Ramadan</h2>}
            </>
          )}
          {diffDays - 1 === 0 && <h2>Ramadan Starts Tomorrow!</h2>}
        </div>
			</div>
			<div className='timer'>
				{isEidDay ? (
					<>
						<h2>No fasting today! Wishing you and your family a happy Eid!</h2>
						<h1>Eid Mubarak!</h1>
					</>
				) : (
					<>
            <h3>
              Time remaining till {sehriTimeDiff.diff > 0
                ? isMonthOfRamadan ? 'end of Sehri' : 'Sunrise'
                : isMonthOfRamadan ? 'Iftar' : 'Sunset'}:
            </h3>
            {sehriTimeDiff.diff > 0 ? <h2>{timeString}</h2> : <h1>{timeString}</h1>}
          </>
				)}
			</div>
		</>
	);
}

export default Timer;
